import { ErrorCode } from '@afterpaytouch/portal-api/types'

export const isCardScanRequired = (error: any): boolean => error?.data?.errorCode === ErrorCode.CardScanRequired
